export const GETIDLETIME = 'getIdleTime';
export const SETIDLETIME = 'setIdleTime';

const state = {
    idleTime: false
};

const getters = {
    isIdleTime(state) {
        return state.idleTime;
    },
};

const actions = {
    [GETIDLETIME](state) {
        return state.isIdleTime
    },
};

const mutations = {
    [SETIDLETIME](state) {
        state.idleTime = true;
    },
};

export default {
    state,
    actions,
    mutations,
    getters
};
